export const ratingMapper: { [key: string]: string } = {
    one: "U",
    two: "U/A",
    three: "7+",
    four: "A",
    five: "R",
  };
  